import React from 'react';
import { Modal, Select } from 'antd';
import ModalHeader from 'common/components/modal-header';
import { useBookingStatusModal } from './hooks';

const BookingStatusModal = props => {
  const {
    loading,
    visible,
    options,
    newStage,
    t,
    handleUpdateStatus,
    handleCloseStatus,
    handleSelectChange,
  } = useBookingStatusModal(props);
  return (
    <Modal
      visible={visible}
      width={450}
      okButtonProps={{ loading: loading }}
      okText={t('cms:cms.booking.modal.status.ok_btn')}
      onOk={handleUpdateStatus}
      cancelText={t('cms:cms.booking.modal.status.cancel_btn')}
      onCancel={handleCloseStatus}
      wrapClassName="booking-status-modal"
    >
      <ModalHeader title={t('cms:cms.booking.modal.status.title')} />
      <div className="booking-status-modal__label--required">
        {t('cms:cms.booking.modal.status.label')}
      </div>
      <Select
        value={newStage}
        style={{ width: '100%' }}
        placeholder={t('cms:cms.booking.modal.status.select_placeholder')}
        onChange={handleSelectChange}
      >
        {options.map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.text}
          </Select.Option>
        ))}
      </Select>
    </Modal>
  );
};

export default BookingStatusModal;
